import React from 'react';
const facts = [{
  value: '134',
  label: 'Ready-to-run sessions',
  color: 'text-coral-deep'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses',
  color: 'text-indigo'
}, {
  value: '3',
  label: 'Levels on every session',
  color: 'text-teal-deep'
}, {
  value: '180',
  label: 'Prompts ready to read aloud',
  color: 'text-amber-deep'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-369" data-mp="32j4iokfhbp00">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-12" data-id="element-370" data-mp="32htieul8szdn">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cloud-dark bg-cloud-dark sm:grid-cols-4" data-id="element-371" data-mp="2xk9tn0qx547g">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-372" data-mp="2tkj573ov7063">
              <div className={`font-display text-4xl font-extrabold leading-none sm:text-5xl ${fact.color}`} data-id="element-373" data-mp="2oitrthe66aeu">{fact.value}</div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-374" data-mp="1i0wxjm9dx1ja">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}